/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".successmsg[_ngcontent-%COMP%]{text-align:center;width:100%;display:block;padding:15px 0;font-size:25px;font-weight:bolder}button.primary[_ngcontent-%COMP%]{color:#000}"];
export { styles as styles };
